import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ReferralHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Check for referral parameter on page load
    const urlParams = new URLSearchParams(location.search);
    const referrerId = urlParams.get('ref');

    if (referrerId) {
      // Store referrer ID in localStorage for later use during signup
      localStorage.setItem('referrer_id', referrerId);
      
      // Validate the referrer ID immediately
      validateReferrer(referrerId);
      
      // Clean URL by removing the ref parameter (optional, for cleaner UX)
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete('ref');
      window.history.replaceState({}, document.title, newUrl.pathname);
      
      console.log('Referral detected:', referrerId);
    }
  }, [location]);

  const validateReferrer = async (referrerId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/referral/validate-referrer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ referrer_id: referrerId })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.valid) {
          // Store validation status
          localStorage.setItem('referrer_validated', 'true');
          console.log('Referrer validated successfully');
        } else {
          // Remove invalid referrer
          localStorage.removeItem('referrer_id');
          console.log('Invalid referrer:', data.reason);
        }
      }
    } catch (error) {
      console.error('Error validating referrer:', error);
      // Keep referrer ID even if validation fails (network issues)
    }
  };

  // This component doesn't render anything
  return null;
};

export default ReferralHandler;